import React, { useState } from 'react';
import './ProfileForm.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const ProfileForm = ({ user, onClose, onUpdate }) => {
  const [formData, setFormData] = useState({
    first_name: user.profile?.first_name || '',
    last_name: user.profile?.last_name || '',
    email: user.profile?.email || '',
  });
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage('');

    try {
      const response = await fetch(`${API_URL}/api/profile/`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-User-ID': user.userId,
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const updatedUser = await response.json();
        setMessage('Profile updated successfully!');
        
        // Call onUpdate if it exists and is a function
        if (onUpdate && typeof onUpdate === 'function') {
          onUpdate(updatedUser);
        }
        
        onClose();
      } else {
        const errorText = await response.text();
        console.error('Profile update error:', errorText);
        setMessage('Error updating profile');
      }
    } catch (error) {
      console.error('Profile update - Network error:', error);
      setMessage(`Network error: ${error.message}`);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="profile-form-overlay">
      <div className="profile-form">
        <h3>Update Profile</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>First Name</label>
            <input
              type="text"
              value={formData.first_name}
              onChange={(e) => setFormData({...formData, first_name: e.target.value})}
            />
          </div>
          <div className="form-group">
            <label>Last Name</label>
            <input
              type="text"
              value={formData.last_name}
              onChange={(e) => setFormData({...formData, last_name: e.target.value})}
            />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
            />
          </div>
          {message && (
            <div className={`message ${message.includes('Error') || message.includes('error') ? 'error' : 'success'}`}>
              {message}
            </div>
          )}
          <div className="form-actions">
            <button type="button" onClick={onClose}>Cancel</button>
            <button type="submit" disabled={saving}>
              {saving ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
    
  );
};

export default ProfileForm;